import { render } from "./deliver.vue?vue&type=template&id=267fb594&scoped=true"
import script from "./deliver.vue?vue&type=script&lang=js"
export * from "./deliver.vue?vue&type=script&lang=js"

import "./deliver.vue?vue&type=style&index=0&id=267fb594&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-267fb594"

export default script